module.exports = __webpack_public_path__ + "img/logo-large.59fa6dbf.svg";